import {
 basePath
} from '../common/path'

const path = {
    index: basePath.concat('/ges'),
    get: basePath.concat('/ges'),
    store: basePath.concat('/ges'),
    edit: basePath.concat('/ges/update'),
    forget: basePath.concat('/ges'),
    employees: '/employees',
    employeesByLocation: basePath.concat('/employee/by-location'),
    saveEmployeesIpt: basePath.concat('/ipt'),
    getEmployeesIpt: basePath.concat('/ipt/ges'),
    getQuestion: basePath.concat('/ipt/questions'),
    saveQuestion: basePath.concat('/ipt'),
    getAnswers: basePath.concat('/ipt'),
    dowloanFileIpt: basePath.concat('/ipt'),
    getQuestionRisk: basePath.concat('/potential-risk'),
    saveQuestionRisk: basePath.concat('/potential-risk'),
    answersRisk: basePath.concat('/potential-risk'),
    editRisk: basePath.concat('/potential-risk'),
    historyRisk: basePath.concat('/potential-risk'),
}
export { path }